import React, { useState } from 'react';
import { Button,Box } from "@mui/material";
import { GridToolbarContainer, GridToolbarFilterButton,GridToolbarDensitySelector } from "@mui/x-data-grid-premium";
import Api from '../../../services/Api';

import * as XLSX from 'xlsx';
import moment from 'moment';
function ToolbarVadis({ seachData,filterData,isLoading,setIsLoading }) {
    const [ erreurs,setErreurs ] = useState([]);
    const api = new Api();
    const onExportClick = async () => {
       try{
        setIsLoading(true);
        var formdata = new FormData();
        setErreurs([]);setIsLoading(true);
        var url = `/paiement/ct/exporter`;
       
        // if( seachData?.startDate || seachData?.endDate ){
        //    formdata.append('filterDate',JSON.stringify(seachData));
        // }
        if( filterData.items.length > 0){
            seachData['items'] = filterData.items
        }
        formdata.append('filterData',JSON.stringify(seachData));
        const { status,data,errors} = await api.apiData("post",url,formdata);
        setIsLoading(false);
       if( status === 200 ) {
         if( data.length > 0 ){
          const workbook = XLSX.utils.book_new();
          const _data = data.map((dt, index) => {
            const montantht =  !isNaN(dt.price) ? (dt.price / (1 + 18/100)).toFixed(2): 0;
            const montant_tx = !isNaN(dt.price) ? (parseFloat(dt.price) - (dt.price / (1 + 18/100))).toFixed(2) : 0
              return {
                  Ordre: index + 1,
                  Categorie: dt.name,
                  chassis: dt.chassis,
                  reference: dt.reference,
                  agence: dt.nom_agence,
                  "Type Client": dt.typeClient.charAt(0).toUpperCase() + dt.typeClient.slice(1),
                  "numéro Immat": dt.numImmat,
                  FullName: (dt.typeClient === "société" || dt.typeClient === "gouvernement") ? dt.organisation : dt.nomComplet,
                  Telephone: dt.telephone,
                  Email: dt.email ? dt.email : "Non fournie",
                  "Mode paiement": dt.mode_paiement.charAt(0).toUpperCase() + dt.mode_paiement.slice(1),
                  Montant_tva: montant_tx ,
                  Montant_ht: montantht,
                  Montant_ttc: dt.price || 0,
                  numeropv:dt.pvnumber || "Non fournie",
                  Status: dt.status,
                  Agent: dt.prenom + " " + dt.nomUser,
                  Date: moment(dt.pupdated_at).format("Do MMM YYYY")
              }
          });

      // Calcul des totaux
      const totals = _data.reduce((acc, row) => {
          acc.Montant_tva += row.Montant_tva;
          acc.Montant_ht += row.Montant_ht;
          acc.Montant_ttc += row.Montant_ttc;
          return acc;
      }, { Montant_tx: 0, Montant_ht: 0, Montant_ttc: 0 });

      // Création de la feuille avec les données
      const worksheet = XLSX.utils.json_to_sheet(_data);

      // Préparer la ligne de totaux
      const headers = Object.keys(_data[0]);
      const lastRow = _data.length;

      // Créer un tableau pour la ligne de totaux
      const totalRow = headers.map(header => {
          if (header === "Ordre") return "TOTAL";
          if (header === "Montant_tva") return totals.Montant_tva;
          if (header === "Montant_ht") return totals.Montant_ht;
          if (header === "Montant_ttc") return totals.Montant_ttc;
          return ""; // Valeur vide pour les autres colonnes
      });

      // Ajouter la ligne de totaux
      XLSX.utils.sheet_add_aoa(worksheet, [totalRow], { origin: -1 });

      // Mettre en forme les totaux (en gras)
      ['Montant_tva', 'Montant_ht', 'Montant_ttc'].forEach(col => {
          const colIndex = headers.indexOf(col);
          if (colIndex !== -1) {
              const cellAddress = XLSX.utils.encode_cell({ r: lastRow, c: colIndex });
              if (!worksheet[cellAddress]) {
                  worksheet[cellAddress] = { t: 'n', v: totals[col] };
              }
              worksheet[cellAddress].s = { font: { bold: true } };
          }
      });

      // Mettre à jour la plage de la feuille
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      range.e.r = lastRow;
      worksheet['!ref'] = XLSX.utils.encode_range(range);

      // Ajouter la feuille au classeur
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Statistique');

       // Générer le fichier Excel
      XLSX.writeFile(workbook, 'export_' + moment().format('dddd-Do-MMMM-YYYY HH:mm') + '.xlsx');
      }
     }
     }
     catch(e){
        setIsLoading(false);
     }
    }
    return (
        <GridToolbarContainer>
          <GridToolbarFilterButton />  
          <GridToolbarDensitySelector />
          <Box sx={{ display: 'flex'}}>
            <Button 
            variant="text" 
            onClick={onExportClick}
            disabled={isLoading}
            >
            Exporter
            </Button>
        
          </Box>
        
        </GridToolbarContainer>
      );
}
export default ToolbarVadis;